"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const Link_elements_1 = require("./Link.elements");
const Link = ({ children, onClick, href }) => {
    return (react_1.default.createElement(Link_elements_1.StyledLink, { onClick: onClick, href: href }, children));
};
exports.Link = Link;
